import ScrollSideBar from "../ScrollSideBar/ScrollSideBar";
import { CRM_SECTION_IDENTIFIER } from "@Settings/Constants/AdministrationTools/AdministrationTools";

const menus = {
	DEALERINFO: [
		{
			id: 1,
			label: "Location",
			elementId: "Location",
		},
		{
			id: 2,
			label: "Store Picture",
			elementId: "StorePicture",
		},
		{
			id: 3,
			label: "Location Dealer Codes",
			elementId: "LocationDealerCodes",
		},
	],

	PARTNERINTEGRATIONS: [
		{
			id: 1,
			label: "Payroll Provider",
			elementId: "PayRollProvider",
			yCoordinate: 0,
		},
		{
			id: 2,
			label: "Dealer Management System",
			elementId: "DealerManagementSystem",
			yCoordinate: 200,
		},
		{
			id: 3,
			label: "Reputation Management",
			elementId: "ReputationManagement",
			yCoordinate: 510,
		},
		{
			id: 4,
			label: "Opportunity Mining",
			elementId: "OpportunityMining",
			yCoordinate: 650,
		},
		{
			id: 5,
			label: "Phone Service Provider",
			elementId: "PhoneServiceProvider",
			yCoordinate: 700,
		},
		{
			id: 6,
			label: "Inventory Services",
			elementId: "InventoryServices",
			yCoordinate: 750,
		},
		{
			id: 8,
			label: "Global Positioning Service",
			elementId: "GlobalPositioningService",
			yCoordinate: 800,
		},
		{
			id: 9,
			label: "Key Management System",
			elementId: "KeyManagementSystem",
			yCoordinate: 850,
		},
		{
			id: 10,
			label: "Customer Relations Management",
			elementId: CRM_SECTION_IDENTIFIER,
			yCoordinate: 900,
		},
	],
};

type AdministrationToolsSideBarProps = {
	tab: keyof typeof menus;
	activeDefault: string;
	itemClick: (elementId: string, yCoordinate: number) => void;
};
export default function AdministrationToolsSideBar(props: Readonly<AdministrationToolsSideBarProps>) {
	const handleClick = (selection: { elementId: string; yCoordinate: number }) => {
		if (selection?.elementId !== props.activeDefault) {
			props.itemClick(selection.elementId, selection.yCoordinate);
		}
	};

	return (
		<ScrollSideBar
			title={"Administration Tools"}
			position={"sticky"}
			top={"190px"}
			menus={menus?.[props.tab] || []}
			selected={props.activeDefault}
			selectBy={"elementId"}
			showBy={"label"}
			scrollBy={"elementId"}
			listItemClasses={"system-settings-list-item"}
			defaultSelection
			titleSx={{ marginLeft: "6px" }}
			onActionClick={(group) => handleClick(group)}
		/>
	);
}
